import { makeStyles } from "@material-ui/core/styles";
import AddBox from "@material-ui/icons/AddBox";
import ArrowUpward from "@material-ui/icons/ArrowUpward";
import Check from "@material-ui/icons/Check";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import Clear from "@material-ui/icons/Clear";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import Edit from "@material-ui/icons/Edit";
import FilterList from "@material-ui/icons/FilterList";
import FirstPage from "@material-ui/icons/FirstPage";
import LastPage from "@material-ui/icons/LastPage";
import Remove from "@material-ui/icons/Remove";
import SaveAlt from "@material-ui/icons/SaveAlt";
import Search from "@material-ui/icons/Search";
import ViewColumn from "@material-ui/icons/ViewColumn";
import MaterialTable from "material-table";
import React, { forwardRef } from "react";
import { decrypt } from "../CryptoUtilHelper";
import LinkText from "./LinkText";
import CopyText from "./CopyText";
import CopyHideText from "./CopyHideText";

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowUpward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};

const useStyles = makeStyles(theme => ({
  root: {
    //maxWidth: 360,
    backgroundColor: "#344955" //theme.palette.background.paper
  },
  nested: {
    paddingLeft: theme.spacing(4)
  }
}));

export default function MaterialTableHelper(props) {
  const classes = useStyles();

  let data = [];
  props.items.map(item => {
    let d = JSON.parse(decrypt(item.val(), props.ek));
    data.push(d);
    return d;
  });

  return (
    <div style={{ maxWidth: "100%" }}>
      <MaterialTable
        style={{ backgroundColor: "#FFF" }}
        className={classes.root}
        icons={tableIcons}
        columns={[
          { title: "Title", field: "title", render: rowData => <CopyText url={rowData.title} /> },
          { title: "Username", field: "username", render: rowData => <CopyText url={rowData.username} /> },
          { title: "Password", field: "password", render: rowData => <CopyHideText url={rowData.password}/> },
          { title: "Link", field: "url", render: rowData => <LinkText url={rowData.url} /> },
          { title: "Note", field: "note", render: rowData => <CopyText url={rowData.note} /> },
        ]}
        data={data}
        title={"Your last login is at " + new Date(props.userData.metadata.lastSignInTime).toString()}
      />
    </div>
  );
}
